export default __webpack_public_path__ + "static/media/logo192.2c439379.png";